import EditUom from './EditUom'

export default EditUom



// WEBPACK FOOTER //
// ./src/components/Uoms/Edit/index.js